enum SaleChannelType {
  CHECKOUT = 'CHECKOUT',
  SHOPN = 'SHOPN',
  BUNJANG = 'BUNJANG',
  BAND = 'BAND',
  LINE = 'LINE',
  STYLEWINDOW = 'STYLEWINDOW',
  LINEDEAL = 'LINEDEAL',
  EASYBOOKING = 'EASYBOOKING',
  NAVERCAFE = 'NAVERCAFE',
  GIFTING = 'GIFTING',
}

namespace SaleChannelType {
  const values = {
    CHECKOUT: {
      name: '네이버페이 가맹점',
      code: 'CMA4CHK',
      reviewWritable: true,
    },
    SHOPN: {
      name: '스마트스토어',
      code: 'CMA4SHOPN',
      reviewWritable: true,
    },
    BUNJANG: {
      name: '번개장터',
      code: 'BUNJANG',
      reviewWritable: true,
    },
    BAND: {
      name: '밴드',
      code: 'CMA4BAND',
      reviewWritable: false,
    },
    LINE: {
      name: '라인',
      code: 'CMA4LINE',
      reviewWritable: false,
    },
    STYLEWINDOW: {
      name: '스타일윈도우',
      code: 'CMA4STYLW',
      reviewWritable: true,
    },
    LINEDEAL: {
      name: '라인딜',
      code: 'CMA4LINEDL',
      reviewWritable: false,
    },
    EASYBOOKING: {
      name: '네이버 예약',
      code: 'CMA4EASYBK',
      reviewWritable: false,
    },
    NAVERCAFE: {
      name: '카페',
      code: 'CMA4CAFE',
      reviewWritable: true,
    },
    GIFTING: {
      name: '선물하기',
      code: 'CMA4GIFT',
      reviewWritable: true,
    },
  }

  export const getName = (type: SaleChannelType): string => {
    return values[type] && values[type].name
  }

  export const isReviewWritable = (type: SaleChannelType): boolean => {
    return values[type] && values[type].reviewWritable
  }
}

export default SaleChannelType
